import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToAnchor = () => {
   const { hash } = useLocation();

   useEffect(() => {
      if (hash) {
         setTimeout(() => {
            const id = hash.substring(1);
            const element = document.getElementById(id);
            if (element) {
               const isMobile = window.innerWidth <= 768;
               const yOffset = isMobile ? -30 : -100;
               const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
               window.scrollTo({ top: y, behavior: 'smooth' });
            }
         }, 0);
      }
   }, [hash]);

   return null;
};
